import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paywithmobile",
  "use": "paywithmobile-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"paywithmobile\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 2.75C5 1.784 5.784 1 6.75 1h10.5c.966 0 1.75.784 1.75 1.75v18.5A1.75 1.75 0 0117.25 23H6.75A1.75 1.75 0 015 21.25V2.75zM9.75 18.5a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol